/*!
 * mh-bild-sprache.js (MagicHolz, 09.10.2026)
 *
 * Zeigt auf den fremdsprachigen Shop-Versionen (en./fr./nl.magicholz.de) statt eines deutschen Text-Bilds
 * die englische Fassung, falls es sie gibt. Unabhaengig von Weglot-Media-Uebersetzungen.
 *
 * Konvention: Die englische Fassung liegt in Shopify unter Inhalt > Dateien und heisst wie das deutsche
 * Bild, nur mit dem Praefix "en_" (Beispiel: luminous-globus-masse.jpg -> en_luminous-globus-masse.jpg).
 * Das Skript fragt pro Bild einmal an, ob die en_-Datei existiert, und tauscht nur bei Treffer.
 * Kein Treffer = Bild bleibt wie es ist. Das Ergebnis wird pro Browser-Sitzung gemerkt (sessionStorage).
 *
 * Freischaltung pro Produkt ueber das Produkt-Tag "bild-en" (snippets/mh-bild-sprache.liquid). Das Snippet
 * gibt die Dateinamen der Produktbilder als JSON aus (id="mh-bild-sprache-data"); nur diese werden geprueft.
 *
 * Getauscht wird in src, srcset, data-src und data-srcset von <img> und <source> sowie in href von <a>
 * (Galerie, Thumbnails, Zoom/Lightbox, nachgeladene Bilder, Variantenwechsel). Auch Dateinamen mit
 * Shopify-Groessensuffix (name_0x.jpg, name_1500x.jpg) werden erkannt. Auf der deutschen Seite passiert nichts.
 *
 * Test: ?mh_lang=en an eine Produkt-URL haengen (erzwingt die Sprache). Ergebnis steht im Attribut
 * data-mh-bild-sprache am <html>-Tag (Sprache:getauschte Attribute:gefundene EN-Dateien).
 */
(function () {
  'use strict';

  var PREFIX = 'en_';
  var DATA_ID = 'mh-bild-sprache-data';
  var ATTRS = ['src', 'srcset', 'data-src', 'data-srcset', 'href'];
  var SEL = 'img,source,a';
  var STORE = 'mhbs1:';
  var SIZE_RE = /_\d*x\d*(?=\.[a-z0-9]+$)/i; // Shopify-Groessensuffix vor der Endung (name_0x.jpg)
  // .../files/<dateiname>  (Dateiname endet an ? # Leerzeichen Komma oder Ende; ohne bereits vorhandenes en_)
  var FILE_RE = /\/files\/(?!en_)([^\/?#\s,]+)(?=[?#\s,]|$)/g;

  function getLang() {
    var q = /[?&]mh_lang=([a-z]{2})(?:&|#|$)/i.exec(location.search);
    if (q) return q[1].toLowerCase();
    var h = /^([a-z]{2})\./i.exec(location.hostname);
    if (h) return h[1].toLowerCase();
    var l = (document.documentElement.getAttribute('lang') || '').slice(0, 2).toLowerCase();
    return l || 'de';
  }

  var lang = getLang();
  if (lang === 'de') return;

  var node = document.getElementById(DATA_ID);
  if (!node) return;
  var list;
  try {
    list = JSON.parse(node.textContent || '[]');
  } catch (e) {
    return;
  }
  if (!Array.isArray(list) || !list.length) return;

  var allowed = Object.create(null); // Dateiname (klein) -> true: nur Bilder dieses Produkts
  var verdict = Object.create(null); // Dateiname (klein) -> 1 (en_-Datei da) | 0 (keine)
  var probing = Object.create(null);
  list.forEach(function (n) {
    var k = String(n).toLowerCase();
    if (!k || k.indexOf(PREFIX) === 0) return;
    allowed[k] = true;
    try {
      var s = sessionStorage.getItem('' + STORE + k);
      if (s === '1' || s === '0') verdict[k] = +s;
    } catch (e) { /* ohne Speicher einfach jedes Mal pruefen */ }
  });

  var swaps = 0;
  var hits = 0;

  function remember(k, v) {
    verdict[k] = v;
    try { sessionStorage.setItem('' + STORE + k, String(v)); } catch (e) { /* egal */ }
  }

  function report() {
    document.documentElement.setAttribute('data-mh-bild-sprache', lang + ':' + swaps + ':' + hits);
  }

  // Prueft per kleinem Bild-Request (Breite 32), ob es die en_-Datei gibt.
  function probe(k, attrValue) {
    if (probing[k]) return;
    var base = '/files/' + k.replace(/\.[a-z0-9]+$/i, '');
    var tok = attrValue.split(',').map(function (s) { return s.trim().split(/\s+/)[0]; }).filter(function (t) {
      return t.toLowerCase().indexOf(base) > -1;
    })[0];
    if (!tok) return;
    var url;
    try {
      var u = new URL(tok, location.href);
      u.pathname = u.pathname.replace(/\/([^\/]+?)(?:_\d*x\d*)?(\.[a-z0-9]+)$/i, '/' + PREFIX + '$1$2');
      u.search = '?width=32';
      u.hash = '';
      url = u.href;
    } catch (e) {
      return;
    }
    probing[k] = true;
    var img = new Image();
    img.onload = function () {
      hits++;
      remember(k, 1);
      scan(document.documentElement);
      report();
    };
    img.onerror = function () {
      remember(k, 0);
      report();
    };
    img.src = url;
  }

  function swapEl(el) {
    for (var i = 0; i < ATTRS.length; i++) {
      var v = el.getAttribute(ATTRS[i]);
      if (!v || v.indexOf('/files/') === -1) continue;
      var changed = false;
      var n = v.replace(FILE_RE, function (m, name) {
        var k = name.toLowerCase();
        if (!allowed[k]) k = k.replace(SIZE_RE, '');
        if (!allowed[k]) return m;
        if (verdict[k] === 1) {
          changed = true;
          return '/files/' + PREFIX + name;
        }
        if (verdict[k] === undefined) probe(k, v);
        return m;
      });
      if (changed) {
        el.setAttribute(ATTRS[i], n);
        swaps++;
      }
    }
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches(SEL)) swapEl(root);
    var found = root.querySelectorAll ? root.querySelectorAll(SEL) : [];
    for (var i = 0; i < found.length; i++) swapEl(found[i]);
  }

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      if (m.type === 'childList') {
        for (var j = 0; j < m.addedNodes.length; j++) scan(m.addedNodes[j]);
      } else if (m.target && m.target.matches && m.target.matches(SEL)) {
        swapEl(m.target);
      }
    }
    report();
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ATTRS
  });

  scan(document.documentElement);
  report();
})();
